import axios from "axios";
import { Loading, Notify } from "notiflix";
import { APIURL } from "./config";
import { ACTIVE_QUIZ_STUDENT, ACTIVE_STUDENT, ASSOCIATED_TEACHERS, BASIC_STATE, FILTER_LIST, GALLERY_STUDENT_LIST, QUIZ_STUDENT_ACTIVE_PAGE, STUDENTS_DATA, STUDENT_ACTIVE_PAGE, STUDENT_GALLERY, TEACHER_ACTIVE_PAGE, USER_DATA } from "./types";

export const getFilters = (cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      },
      data: {}
   };
   try {
      Loading.standard();
      const res = await axios.get(`${APIURL}/api/school-dashboard/filters`, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: FILTER_LIST,
            payload: res?.data?.body,
         });
         if (cb) cb(res?.data?.body);
      } else if (!res?.data?.status) {
         dispatch({
            type: FILTER_LIST,
            payload: { filterLevel: [], filters: {} },
         });
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getBasicState = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/basic-stats`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: BASIC_STATE, payload: res?.data?.body })
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         const message = res?.message ?? "something went wrong";
         Notify.warning(message);
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const getStudentGallery = (data) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/gallery/student-gallery`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({
            type: STUDENT_GALLERY,
            payload: res?.data?.body,
         });
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}


export const studentsByPerformance = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/student-performance`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: ACTIVE_STUDENT, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: ACTIVE_STUDENT,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const quizStudentsByPerformance = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/student-performance`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: ACTIVE_QUIZ_STUDENT, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: ACTIVE_QUIZ_STUDENT,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const studentsByCategory = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/category-wise`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: STUDENTS_DATA, payload: res?.data?.body })
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const usersByPerformance = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/users-performance`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: USER_DATA, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({ type: USER_DATA, payload: {} })
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const setFilters = (type, data) => async dispatch => {
   dispatch({ type: type, payload: data })
}

export const getAssociatedTeachers = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/associated-teachers`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: ASSOCIATED_TEACHERS, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: ASSOCIATED_TEACHERS,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const setStudentActivePage = page => async dispatch => {
   dispatch({ type: STUDENT_ACTIVE_PAGE, payload: page });
}

export const setQuizStudentActivePage = page => async dispatch => {
   dispatch({ type: QUIZ_STUDENT_ACTIVE_PAGE, payload: page });
}

export const setTeacherActivePage = page => async dispatch => {
   dispatch({ type: TEACHER_ACTIVE_PAGE, payload: page });
}

export const galleryStudentList = (data) => async dispatch => {

   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/school-dashboard/kid-list`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         dispatch({ type: GALLERY_STUDENT_LIST, payload: res?.data?.body })
      } else if (!res?.data?.status) {
         dispatch({
            type: GALLERY_STUDENT_LIST,
            payload: {},
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}